class FilterReferences {
	constructor() {
		this.RefContainer = document.getElementById("references");
		this.refItems = document.querySelectorAll("#references .col-reference");

		if (!this.RefContainer) {
			return;
		}

		this.initOrderFilter();
	}

	initOrderFilter() {
		const ascFilter = document.querySelector(".order-asc");
		const descFilter = document.querySelector(".order-desc");


		ascFilter.addEventListener("click", () => {
			ascFilter.classList.add("current");
			descFilter.classList.remove("current");
			this.doOrderFlip();

		});

		descFilter.addEventListener("click", () => {
			ascFilter.classList.remove("current");
			descFilter.classList.add("current");
			this.doOrderFlip();

		});
	}

	doOrderFlip() {
		gsap.to("#references .col-reference", {
			duration: 0.4,
			autoAlpha: 0,
			y: 10,
			ease: "power1.inOut",
			stagger: 0.05,
			onComplete: () => {
				this.ReorderChildren(this.RefContainer);
				gsap.to("#references .col-reference", {
					duration: 0.3,
					autoAlpha: 1,
					y: 0,
					ease: "power1.inOut",
					stagger: 0.05
				});
			}
		});

	}

	ReorderChildren(parent) {
		for (var i = 1; i < parent.childNodes.length; i++){
			parent.insertBefore(parent.childNodes[i], parent.firstChild);
		}
	}


}